import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    academic_year: '',
    grade_level: '',
    mentor: '',
  },
}

export const groupsUI = createSlice({
  name: 'groupsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setAcademicYear: (state, { payload }) => {
      state.tableFilters.academic_year = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.tableFilters.grade_level = payload
    },
    setMentor: (state, { payload }) => {
      state.tableFilters.mentor = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setAcademicYear,
  setGradeLevel,
  setMentor,
  trackActiveFilters,
  clearAllFilters,
} = groupsUI.actions

export default groupsUI.reducer
